module.exports = __webpack_public_path__ + "img/vk.2736c182.svg";